import axios from 'axios';
import { BASE_URL, config } from '../constants';

export function getNotaries(){
    return axios.get(`${BASE_URL}/notaries/`, config);
}